import {
  CommonSelect,
  DatePicker,
  Input,
  LoadingButton,
  SwitchButton,
  TextArea,
} from "components/form";
import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { surveyCategoryListApi } from "services/master";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import {
  formatMultiSelectArray,
  getValuesByKey,
  handleDynamicList,
  isArrayEmpty,
  isObjectEmpty,
  isTrue,
  removeEmptyValues,
  transformArrayToObject,
  validateOnlyNumber,
} from "utils/commonHelper";
import {
  addDaysToDateString,
  addYearsToDateString,
  toDate,
} from "utils/dateHelper";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useSelector } from "react-redux";
import { removeErrorFields, validateInput } from "validation";
import { getFromLocal } from "config/axiosInstance";
import {
  createSurveyApi,
  getPaymentLinkApi,
  surveyDetailsApi,
} from "services/survey";
import {
  handleDecryptionParams,
  handleEncryptionParams,
} from "utils/dataCipherHelper";
import SurveyInfo from ".././SurveyInfo";
import { survey } from "../../../../validation/schema/survey";
import "../CreateSurvey.scss";
import {
  ANNUAL_INCOMES,
  EDUCATION_LEVELS,
  LIVING_SITUATIONS,
  MARITAL_STATUSES,
  multiLangStaticObject,
  SURVEY_DURATION,
  SURVEY_SLIDER_DATA,
  USER_EMPLOYEMENT,
  USER_GENDER,
} from "constant/staticData";
import { toastMessage } from "utils/toastMessageHelper";
import useShimmer from "hooks/useShrimmer";
import StructurePreviewShimmer from "shrimmer/Survey/StructurePreviewShimmer";
import SurveyInfoShimmer from "shrimmer/Survey/SurveyInfoShimmer";
import { LuInfo } from "react-icons/lu";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const StructurePreview = () => {
  const [showShimmer, setShowShimmer] = useShimmer(StructurePreviewShimmer);
  const [showSurveyInfoShimmer, setShowSurveyInfoShimmer] =
    useShimmer(SurveyInfoShimmer);
  const regionList = useSelector((state) => state.regionList);
  // All Set Value
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedSurveyDetail, setSelectedSurveyDetail] = useState({});

  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams
  );

  const selectedSurveyId = getParamsData?.surveySlug || "";

  const [error, setError] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({
    gender: "",
    age: "",
    educationLevel: "",
    livingSituation: "",
    region: "",
    employementInfo: "",
    martialStatus: "",
    annualIncome: "",
    duration: "",
    surveyCategory: "",
  });
  const [surveyCategoryList, setSurveyCategoryList] = useState([]);
  const [surveyButtonLoader, setSurveyButtonLoader] = useState(false);
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [sliderMaxValue, setSliderMaxValue] = useState(1000);
  const [surveyIDForPayment, setSurveyIDForPayment] = useState("");

  const { t, i18n } = useTranslation();

  // Handlers function

  // Fetch Survey Category list Handler
  const fetchSurveyCategoryList = async () => {
    try {
      const response = await surveyCategoryListApi();
      if (response.status === 200) {
        const { surveyCategory = [] } = response.data || {};

        setSurveyCategoryList(surveyCategory);
      }
    } catch (e) {
      console.error("Error fetching survey categories:", e.message);
    }
  };

  // Input Validation function
  const validation = () => {
    const { errors, status } = validateInput(
      selectedSurveyDetail,
      "createSurveySchema",
      survey,
      null
    );
    setError(errors);
    return status;
  };

  // Input change Handler
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let updatedValue = value;

    if (["rewardPerPerson", "minAge", "maxAge", "userCount"].includes(name)) {
      updatedValue = validateOnlyNumber(value);
    }

    if (name === "userCount") {
      setSliderMaxValue(updatedValue);
    }

    setSelectedSurveyDetail((prev) => ({ ...prev, [name]: updatedValue }));
    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Switch Change handler
  const handleSwitchChange = (key) => {
    setSelectedSurveyDetail((prev) => ({
      ...prev,
      [key]: !prev?.[key],
      ...(key === "surveytype" &&
        !prev?.[key] === true && { rewardPerPerson: 0 }),
    }));
  };

  // Date change handler
  const handleDateChange = (dateValue) => {
    setSelectedSurveyDetail((prev) => ({
      ...prev,
      expiryDate: toDate(dateValue),
    }));
  };

  // Filter Chnage Handler
  const handleFilterChange = (filterKey, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [filterKey]: value,
    }));

    setSelectedSurveyDetail({
      ...selectedSurveyDetail,
      [filterKey]:
        formatMultiSelectArray(value, ",", true, "value") || value?.value,
    });

    setError((prevError) => removeErrorFields(prevError, filterKey));
  };

  // Dropdown for multiple value
  const renderSelect = ({
    required,
    placeholder,
    arrayList,
    selectedKey,
    isMulti = true,
    labelKey = "label",
    valueKey = "value",
    sourcekey = "label",
    sourceValue = "value",
    error = null,
  }) => (
    <CommonSelect
      required={required}
      label={placeholder}
      placeholder={placeholder}
      options={handleDynamicList({
        arrayList,
        labelKey: labelKey,
        valueKey: valueKey,
        sourcekey: sourcekey,
        sourceValue: sourceValue,
      })}
      value={selectedFilters[selectedKey]}
      onChange={(value) => handleFilterChange(selectedKey, value)}
      isSearchable
      isMulti={isMulti}
      error={error || null}
    />
  );

  // Mapping data for select
  const mappings = {
    gender: {
      key: "gender",
      list: multiLangStaticObject["MULTI_USER_GENDER"][i18n.language || "en"],
      valueKey: "value",
      labelKey: "label",
    },
    // age: { key: "age", list: USER_AGE, valueKey: "value", labelKey: "label" },
    educationLevel: {
      key: "educationLevel",
      list: multiLangStaticObject["MULTI_EDUCATION_LEVEL"][
        i18n.language || "en"
      ],
      valueKey: "value",
      labelKey: "label",
    },
    livingSituation: {
      key: "livingSituation",
      list: multiLangStaticObject["MULTI_LIVING_SITUATIONS"][
        i18n.language || "en"
      ],
      valueKey: "value",
      labelKey: "label",
    },
    region: {
      key: "region",
      list: regionList,
      valueKey: "_id",
      labelKey: "name",
    },
    employementInfo: {
      key: "employementInfo",
      list: multiLangStaticObject["MULTI_USER_EMPLOYEMENT"][
        i18n.language || "en"
      ],
      valueKey: "value",
      labelKey: "label",
    },
    martialStatus: {
      key: "martialStatus",
      list: multiLangStaticObject["MULTI_MARITAL_STATUSES"][
        i18n.language || "en"
      ],
      valueKey: "value",
      labelKey: "label",
    },
    annualIncome: {
      key: "annualIncome",
      list: multiLangStaticObject["MULTI_ANNUAL_INCOMES"][
        i18n.language || "en"
      ],
      valueKey: "value",
      labelKey: "label",
    },
    duration: {
      key: "duration",
      list: multiLangStaticObject["MULTI_SURVEY_DURATION"][
        i18n.language || "en"
      ],
      valueKey: "value",
      labelKey: "label",
      isSingle: true,
    },
    surveyCategory: {
      key: "surveyCategory",
      list: surveyCategoryList,
      valueKey: "_id",
      labelKey: "name",
      isSingle: true,
      // nestedKey: "_id",
    },
  };

  // // Create Survey function handler
  const createSurveyHandler = async () => {
    if (validation()) {
      try {
        setSurveyButtonLoader(true);
        const {
          _id,
          __v,
          surveyStatus,
          stage,
          surveyCreatedFrom,
          researcherId,
          isPurchased,
          createdAt,
          updatedAt,
          createSurveySlug,
          surveyReferenceNumber,
          totalQuestionCount,
          totalParticipantCount,
          isSurveyFilled,
          ...restSelectedSurveyDetail
        } = selectedSurveyDetail;

        if (isTrue(selectedSurveyDetail?.surveytype)) {
          const reqData = {
            ...restSelectedSurveyDetail,
            surveytype: isTrue(selectedSurveyDetail?.surveytype)
              ? "free"
              : "paid",
            rewardPerPerson: isTrue(selectedSurveyDetail?.surveytype)
              ? 0
              : selectedSurveyDetail?.rewardPerPerson,
            surveyId: selectedSurveyId,
            isCompleted: true,
            publishSurvey: true,
            userCount: selectedSurveyDetail?.userCount || 0,
            token: getFromLocal() || "",
          };

          const responseData = await createSurveyApi(
            removeEmptyValues(reqData)
          );
          const { message = "", status: requstStatus } = responseData;
          if (requstStatus === 200) {
            toastMessage(message, "success", "checkoutSurvey");
            const paramsData = {
              surveySlug: selectedSurveyId,
              stepper: 5,
              publishSurvey: true,
            };
            const encryptedParams = handleEncryptionParams(
              paramsData,
              searchParams
            );
            setSearchParams(encryptedParams);
          }
        } else {
          paymentCheckoutHandler(restSelectedSurveyDetail);
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setSurveyButtonLoader(false);
      }
    }
  };

  // Function for load payment SDK
  const paymentCheckoutHandler = async (selectedSurveyDetail) => {
    try {
      const reqData = {
        isWeb: true,
        token: getFromLocal() || "",
        surveyId: !surveyIDForPayment ? selectedSurveyId : surveyIDForPayment,
        surveyData: {
          ...selectedSurveyDetail,
          isCompleted: selectedSurveyDetail?.isCompleted,
          publishSurvey: selectedSurveyDetail?.publishSurvey,
          surveytype: isTrue(selectedSurveyDetail?.surveytype)
            ? "free"
            : "paid",
          rewardPerPerson: isTrue(selectedSurveyDetail?.surveytype)
            ? 0
            : selectedSurveyDetail?.rewardPerPerson,
          userCount: selectedSurveyDetail?.userCount || 0,
        },
      };

      const responseData = await getPaymentLinkApi(reqData);
      const { status, data, message } = responseData;
      if (status === 200) {
        // toastMessage(message, "success", "checkoutSurvey");
        const url = data?.url;
        window.location.href = url;
      } else {
        const paramsData = {
          surveySlug: !surveyIDForPayment
            ? selectedSurveyId
            : surveyIDForPayment,
          stepper: 4,
        };
        const encryptedParams = handleEncryptionParams(
          paramsData,
          searchParams
        );
        setSearchParams(encryptedParams);
        toastMessage(message, "error", "checkoutSurvey");
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Fetching Selected Survey Details API
  const fetchSelectedSurveyDetail = async () => {
    if (selectedSurveyId) {
      try {
        setShowShimmer(true);
        setShowSurveyInfoShimmer(false);
        const reqData = { surveyId: selectedSurveyId, token: getFromLocal() };
        const responseData = await surveyDetailsApi(reqData);
        const {
          data: { surveyDetail = {} },
          status,
        } = responseData;
        if (status === 200) {
          setSurveyIDForPayment(responseData?.data?.surveyDetail?._id);

          const surveyDetailValue = isObjectEmpty(surveyDetail)
            ? {}
            : formatSurveyDetailValue(surveyDetail);

          // setSelectedSurveyDetail({ ...surveyDetailValue, userCount: 2000 });
          setSelectedSurveyDetail(surveyDetailValue);
          setTotalQuestionCount(surveyDetail?.totalQuestionCount ?? 0);
          setSelectedFilters((prev) => {
            const updatedFilters = {};
            Object.entries(mappings).forEach(([filterKey, config]) => {
              const { key, list, valueKey, labelKey, isSingle, nestedKey } =
                config;

              const detail = nestedKey
                ? surveyDetailValue?.[key]?.[nestedKey]
                : surveyDetailValue?.[key];

              updatedFilters[key] = !isArrayEmpty(detail)
                ? handleArrayValue(
                    isSingle ? [detail] : detail,
                    list,
                    valueKey,
                    labelKey
                  )
                : [];
            });

            return {
              ...prev,
              ...updatedFilters,
            };
          });
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setShowShimmer(false);
        setShowSurveyInfoShimmer(false);
      }
    }
  };

  useEffect(() => {
    fetchSurveyCategoryList();
  }, []);

  useEffect(() => {
    if (surveyCategoryList && !isArrayEmpty(surveyCategoryList)) {
      fetchSelectedSurveyDetail();
    }
  }, [surveyCategoryList]);

  const sliderDynamicMarkValue = (min, max, step) => {
    const minValue = min;
    let maxValue = max;
    let stepValue = Math.floor((maxValue - minValue) / 10);

    if (sliderMaxValue) {
      maxValue = sliderMaxValue;
      stepValue = (sliderMaxValue - minValue) / 10;
    }

    const markValue = Array.from(
      { length: Math.floor((maxValue - minValue) / stepValue) + 1 },
      (_, i) => minValue + i * Math.floor(stepValue)
    ).reduce((acc, val) => {
      acc[val] = val;
      return acc;
    }, {});

    return markValue;
  };

  //**************************** Handle HTML CODE **********************//
  return (
    <div className="participant_criteria structure_preview">
      <h3 className="dashboard_title">
        {t(`PARTICIPANT_CRITERIA.participantCriteria`)}
      </h3>
      {showShimmer || (
        <div className="form_wrap">
          <div className="form_content">
            <form>
              {/* Step 1: Survey Details */}
              <div className="form_section">
                <div className="form_title">
                  <h4>
                    <span className="sr_number">1</span>{" "}
                    {t(`PARTICIPANT_CRITERIA.setSurveyDetail`)}
                  </h4>

                  <label className="switch_wrap">
                    <span className="green">
                      {" "}
                      {t(`PARTICIPANT_CRITERIA.hideMyIdentity`)}
                    </span>
                    <div className="tooltip_wrap">
                      <LuInfo />
                      <span className="tooltip_content">
                        {t(
                          `PARTICIPANT_CRITERIA.hideMyIdentityStructureDescription`
                        )}
                      </span>
                    </div>
                    <SwitchButton
                      status={selectedSurveyDetail.hideIdentity}
                      onChange={() => handleSwitchChange("hideIdentity")}
                    />
                  </label>
                </div>
                <div className="form_field">
                  <Input
                    required={true}
                    label={t(`PARTICIPANT_CRITERIA.surveyTitle`)}
                    type="text"
                    name="title"
                    value={selectedSurveyDetail.title || ""}
                    placeholder={t(`PARTICIPANT_CRITERIA.enterSurveyTitle`)}
                    onChange={handleInputChange}
                    maxLength={150}
                    error={error?.title}
                  />
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    {renderSelect({
                      required: true,
                      placeholder: t(`PARTICIPANT_CRITERIA.selectCategory`),
                      arrayList: surveyCategoryList,
                      selectedKey: "surveyCategory",
                      isMulti: false,
                      labelKey: "name",
                      valueKey: "_id",
                      error: error?.surveyCategory || null,
                    })}
                  </div>
                  <div className="form_field">
                    <DatePicker
                      required={true}
                      label={t(`PARTICIPANT_CRITERIA.expiryDate`)}
                      placeholder={t(`PARTICIPANT_CRITERIA.expiryDate`)}
                      name="expiryDate"
                      value={selectedSurveyDetail.expiryDate || ""}
                      onChange={handleDateChange}
                      minDate={toDate(addDaysToDateString(new Date(), 1))}
                      maxDate={toDate(addYearsToDateString(new Date(), 1))}
                      error={error?.expiryDate}
                    />
                  </div>
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    {renderSelect({
                      required: true,
                      placeholder: t(
                        `PARTICIPANT_CRITERIA.estimateTimeDuration`
                      ),
                      arrayList: SURVEY_DURATION,
                      selectedKey: "duration",
                      isMulti: false,
                      error: error?.duration || null,
                    })}
                  </div>
                  <div className="form_field"></div>
                </div>
              </div>

              {/* Step 2: Survey Overview */}
              <div className="form_section">
                <div className="form_title">
                  <h4>
                    <span className="sr_number">2</span>
                    {t(`PARTICIPANT_CRITERIA.surveyOverview`)}
                  </h4>
                </div>
                <div className="form_field has_word_count">
                  <TextArea
                    required={true}
                    label={t(`PARTICIPANT_CRITERIA.surveyDescription`)}
                    placeholder={t(
                      `PARTICIPANT_CRITERIA.enterSurveyDescription`
                    )}
                    style={{ resize: "none" }}
                    name="description"
                    value={selectedSurveyDetail.description || ""}
                    onChange={handleInputChange}
                    maxLength={500}
                    error={error?.description}
                  />
                  <span className="word_count">{`${
                    selectedSurveyDetail.description?.length || 0
                  }/500`}</span>
                </div>
              </div>

              {/* Step 3: Demographics */}
              <div className="form_section">
                <div className="form_title">
                  <h4>
                    <span className="sr_number">3</span>
                    {t(`STRUCTURE_PREVIEW.demographicOptional`)}
                  </h4>
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    <div className="form_field_wrap">
                      <div className="form_field">
                        <Input
                          label={t(`STRUCTURE_PREVIEW.minimumAgeLimit`)}
                          type="text"
                          name="minAge"
                          value={selectedSurveyDetail?.minAge || ""}
                          placeholder={t(
                            `STRUCTURE_PREVIEW.enterMinimumAgeLimit`
                          )}
                          onChange={handleInputChange}
                          maxLength={2}
                        />
                      </div>{" "}
                      <div className="form_field">
                        <Input
                          label={t(`STRUCTURE_PREVIEW.maximumAgeLimit`)}
                          type="text"
                          name="maxAge"
                          value={selectedSurveyDetail?.maxAge || ""}
                          placeholder={t(
                            `STRUCTURE_PREVIEW.enterMaximumAgeLimit`
                          )}
                          onChange={handleInputChange}
                          maxLength={2}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectGender`),
                      arrayList:
                        multiLangStaticObject["MULTI_USER_GENDER"][
                          i18n.language || "en"
                        ],
                      selectedKey: "gender",
                    })}
                  </div>
                  {/* <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: "Select Age",
                      arrayList: USER_AGE,
                      selectedKey: "age",
                    })}
                  </div> */}
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectEducationLevel`),
                      arrayList:
                        multiLangStaticObject["MULTI_EDUCATION_LEVEL"][
                          i18n.language || "en"
                        ],
                      selectedKey: "educationLevel",
                    })}
                  </div>
                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectLivingSituation`),
                      arrayList:
                        multiLangStaticObject["MULTI_LIVING_SITUATIONS"][
                          i18n.language || "en"
                        ],
                      selectedKey: "livingSituation",
                    })}
                  </div>
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectRegion`),
                      arrayList: regionList,
                      selectedKey: "region",
                      labelKey: "name",
                      valueKey: "_id",
                    })}
                  </div>
                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectEmployment`),
                      arrayList:
                        multiLangStaticObject["MULTI_USER_EMPLOYEMENT"][
                          i18n.language || "en"
                        ],
                      selectedKey: "employementInfo",
                    })}
                  </div>
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectMaritalStatus`),
                      arrayList:
                        multiLangStaticObject["MULTI_MARITAL_STATUSES"][
                          i18n.language || "en"
                        ],
                      selectedKey: "martialStatus",
                    })}
                  </div>
                  <div className="form_field">
                    {renderSelect({
                      required: false,
                      placeholder: t(`STRUCTURE_PREVIEW.selectIncome`),
                      arrayList:
                        multiLangStaticObject["MULTI_ANNUAL_INCOMES"][
                          i18n.language || "en"
                        ],
                      selectedKey: "annualIncome",
                    })}
                  </div>
                </div>
              </div>

              {/* Step 4: Survey Summary */}
              <div className="form_section">
                <div className="form_title">
                  <h4>
                    <span className="sr_number">4</span>
                    {t(`STRUCTURE_PREVIEW.peopleTest`)}
                  </h4>
                  <label className="switch_wrap">
                    <span
                      className="green
                    "
                    >
                      {t(`STRUCTURE_PREVIEW.noIncentiveFreeWork`)}
                    </span>
                    <div className="tooltip_wrap">
                      <LuInfo />
                      <span className="tooltip_content">
                        {t(`STRUCTURE_PREVIEW.noIncentiveFreeWorkDescription`)}
                      </span>
                    </div>
                    <SwitchButton
                      status={selectedSurveyDetail?.surveytype || false}
                      onChange={() => handleSwitchChange("surveytype")}
                    />
                  </label>
                </div>

                <div className="step_slider_wrap">
                  {/* <Slider
                    min={SURVEY_SLIDER_DATA?.MIN_LIMIT}
                    // defaultValue={0}
                    marks={generateSliderMarks(
                      SURVEY_SLIDER_DATA?.MIN_LIMIT,
                      SURVEY_SLIDER_DATA?.MAX_LIMIT,
                      SURVEY_SLIDER_DATA?.STEP_LIMIT
                    )}
                    max={SURVEY_SLIDER_DATA?.MAX_LIMIT}
                    // max={selectedSurveyDetail?.userCount}
                    value={selectedSurveyDetail?.userCount}
                    step={SURVEY_SLIDER_DATA?.STEP_VALUE}
                    // step={10}
                    onChange={(sliderValue) =>
                      setSelectedSurveyDetail((prev) => ({
                        ...prev,
                        userCount: sliderValue,
                      }))
                    }
                  /> */}

                  <Slider
                    min={0}
                    marks={sliderDynamicMarkValue(
                      SURVEY_SLIDER_DATA?.MIN_LIMIT,
                      SURVEY_SLIDER_DATA?.MAX_LIMIT,
                      SURVEY_SLIDER_DATA?.STEP_LIMIT
                    )}
                    // max={SURVEY_SLIDER_DATA?.MAX_LIMIT}
                    max={
                      !sliderMaxValue
                        ? SURVEY_SLIDER_DATA?.MAX_LIMIT
                        : sliderMaxValue
                    }
                    value={selectedSurveyDetail?.userCount}
                    // step={SURVEY_SLIDER_DATA?.STEP_VALUE}
                    onChange={(sliderValue) =>
                      setSelectedSurveyDetail((prev) => ({
                        ...prev,
                        userCount: sliderValue,
                      }))
                    }
                  />

                  <Input
                    // isDisabled={true}
                    name="userCount"
                    className="slider_value"
                    onChange={handleInputChange}
                    value={selectedSurveyDetail?.userCount || ""}
                  />
                </div>
                <p className="my-3">
                  <b>{t(`STRUCTURE_PREVIEW.rewardPerPerson`)}</b>
                  {/* - most popular with mid-large size organizations */}
                </p>
                <Input
                  placeholder={t(`STRUCTURE_PREVIEW.rewardPerParticipant`)}
                  name="rewardPerPerson"
                  onChange={handleInputChange}
                  isDisabled={selectedSurveyDetail?.surveytype}
                  value={selectedSurveyDetail?.rewardPerPerson ?? ""}
                />
              </div>
            </form>
          </div>

          {showSurveyInfoShimmer || (
            <div className="form_summery_wrap">
              <SurveyInfo
                showFooter={true}
                showHeader={true}
                showInnerFooter={true}
                heading={t(`STRUCTURE_PREVIEW.surveyCost`)}
                surveyDetail={selectedFilters}
                totalQuestionCount={totalQuestionCount}
                selectedSurveyDetail={selectedSurveyDetail}
              />
              {isTrue(selectedSurveyDetail?.isCompleted) || (
                <div className="button_wrap">
                  <LoadingButton
                    onClick={createSurveyHandler}
                    loading={surveyButtonLoader}
                  >
                    {t(`STRUCTURE_PREVIEW.checkout`)} <FaArrowRight />
                  </LoadingButton>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StructurePreview;

const formatSurveyDetailValue = (detailValue = {}) => {
  if (isObjectEmpty(detailValue)) {
    return {};
  }
  const modifiedSurveyDetailValue = {
    ...detailValue,
    rewardPerPerson: detailValue?.rewardPerPerson || 0,
    surveytype: detailValue?.surveytype === "paid" ? false : true,
    surveyCategory: detailValue?.surveyCategory?._id || "",
    region: !isArrayEmpty(detailValue?.region)
      ? getValuesByKey(detailValue?.region, "_id")
      : [],
    maxAge: detailValue?.maxAge || "",
    minAge: detailValue?.minAge || "",
  };

  // const {
  //   _id,
  //   __v,
  //   surveyStatus,
  //   stage,
  //   surveyCreatedFrom,
  //   researcherId,
  //   isPurchase,
  //   createdAt,
  //   updatedAt,
  //   createSurveySlug,
  //   surveyReferenceNumber,
  //   totalQuestionCount,
  //   totalParticipantCount,
  //   isSurveyFilled,
  //   ...restSelectedSurveyDetail
  // } = modifiedSurveyDetailValue;

  return modifiedSurveyDetailValue;
};

const handleArrayValue = (mainArray, arrayValue, key, value) => {
  const objectValue = transformArrayToObject(arrayValue, key, value);
  const insideValue = mainArray?.map((item) => ({
    label: objectValue[item],
    value: item,
  }));
  return insideValue;
};
